<template>
  <div class="wrap-box">
    <!-- 退回原因 -->
    <van-notify
      color="#F32222"
      background="#FFDDDD"
      v-model="isAuditReturnStatus"
    >
      <span class="van-notify-label">退回原因：</span>
      <span
        v-if="isAuditReturn"
        class="van-notify-value"
      >{{
        taskDetail.auditReturnReason || "-"
      }}</span>
      <span
        v-else-if="isSettlementReturn"
        class="van-notify-value"
      >{{
        taskDetail.settleReturnReason || "-"
      }}</span>
    </van-notify>
    <!-- 预约时间倒计时 -->
    <van-notify
      color="#464542"
      background="#FEF8EB"
      :value="showArriveTimeCountDown"
    >
      <span>请在</span>
      <CountDown
        v-if="taskDetail.appointmentTime"
        :key="taskDetail.appointmentTime"
        class="count-down"
        :start-time="currentTime()"
        :end-time="getTime(taskDetail.appointmentTime)"
        :day-txt="'天'"
        :hour-txt="'时'"
        :minutes-txt="'分'"
        :seconds-txt="'秒'"
        @end_callback="getTaskDetail"
      />
      <span>内到达服务地点</span>
    </van-notify>
    <!-- 预约时间超时 -->
    <van-notify
      color="#464542"
      background="#FEF8EB"
      :value="showYuyueTimeOut"
    >
      <span>超时</span>
      <CountUp
        v-if="taskDetail.appointmentTime"
        :key="currentTime()"
        class="count-down"
        :start-time="getTime(taskDetail.appointmentTime)"
        :end-time="currentTime()"
        :day-txt="'天'"
        :hour-txt="'时'"
        :minutes-txt="'分'"
        :seconds-txt="'秒'"
      />
      <span>未到达服务地点</span>
    </van-notify>
    <!-- 催单次数 -->
    <van-notify
      color="#F32222"
      background="#FFDDDD"
      v-model="showRemainderNotify"
    >
      <span>已催单{{ taskDetail.remainderCount }}次</span>
    </van-notify>
    <div class="top-box">
      <div
        class="content-box"
        :style="{
          'padding-top':
            isAuditReturnStatus ||
            showArriveTimeCountDown ||
            showYuyueTimeOut ||
            showRemainderNotify
              ? remainderNotifyHeight + 'px'
              : '0',
        }"
      >
        <div class="car-info-box card-box card-padding">
          <div class="card-title">
            <div>
              <span>{{ taskDetail.categoryCodeName }}</span>
              <span
                class="order-tag"
                v-if="taskDetail.vipCompany === '1'"
              >VIP</span>
            </div>
          </div>
          <van-divider style="margin: 16px -16px" />
          <div class="car-info-item">
            <span>服务商：</span>
            <div>
              <span class="car-no">{{
                taskDetail.providerCompanyName || "-"
              }}</span>
            </div>
          </div>
          <div class="car-info-item">
            <span>订单号：</span>
            <span
              class="car-no order-no"
              :class="{
                'color-red': taskDetail.vipCompany === '1',
                'order-svip': isZvVipAndVipCompany,
              }"
            >{{ taskDetail.orderNo || "-" }}</span>
            <div
              class="zv-vip-icon"
              v-if="isShowZvVip"
            >至尊VIP</div>
            <div
              class="zv-vip-icon"
              v-if="isShowBcCustomer"
            >黑钻客户</div>
            <img
              v-if="taskDetail.vipCompany === '1'"
              src="@/assets/img/orderGeneral/vipCompany.png"
              class="vip-icon"
            >
            <div>
              <div
                class="copy-btn"
                @click="copy($event, copyText)"
              >复制</div>
            </div>
          </div>
          <div class="car-info-item">
            <span>服务项目：</span>
            <div>
              <span class="car-no">{{ taskDetail.productSkuName || "-" }}</span>
            </div>
          </div>
          <div class="car-info-item">
            <span>增值产品：</span>
            <span class="car-no">{{
              taskDetail.extraProduct ? extraProductStringList.join(",") : "-"
            }}</span>
          </div>
          <div class="car-info-item">
            <span>救援时间：</span>
            <span class="car-no">{{ taskDetail.appointmentTime || "" }}</span>
            <template v-if="isTakeStatus || isStartStatus">
              <span class="divider">|</span>
              <span
                class="txt-btn"
                @click="editTime"
              >修改</span>
            </template>
          </div>
          <div class="car-info-item">
            <span>车牌号码：</span>
            <span class="car-no">{{ taskDetail.carNo || "-" }}</span>
          </div>
          <div class="car-info-item">
            <span>车架号码：</span>
            <span class="car-no">{{ taskDetail.vinNo || "-" }}</span>
          </div>
          <div class="car-info-item">
            <span>联系人：</span>
            <span class="car-no">{{ taskDetail.contactName || "-" }}</span>
          </div>
          <div class="car-info-item">
            <span>优惠内容：</span>
            <span class="car-no">{{ rightRemark }}</span>
          </div>
          <div class="car-info-item">
            <van-button
              size="small"
              icon="apps-o"
              v-if="
                !isAuditReturnStatus && (isworkStartStatus || isWorkEndStatus)
              "
              @click="showExtraProductBox"
            >
              增值产品
            </van-button>
          </div>
        </div>

        <!-- 地址信息 -->
        <div class="car-info-box card-box card-padding">
          <div class="card-title card-title-flex">
            <div>
              <span>地址信息</span>
              <template v-if="isTrailer">
                <!-- v-if="isTakeStatus || isStartStatus || isArriveStatus" -->
                <span
                  class="map-btn"
                  @click="showMapNavigationStart"
                >
                  <van-icon name="guide-o" />
                  导航到起点
                </span>
                <!-- v-if="taskDetail.destination && isworkStartStatus" -->
                <span
                  class="map-btn"
                  v-if="taskDetail.destination"
                  @click="showMapNavigationEnd"
                >
                  <van-icon name="guide-o" />
                  导航到终点
                </span>
              </template>
              <template v-else>
                <!-- v-if="isTakeStatus || isStartStatus || isArriveStatus" -->
                <span
                  class="map-btn"
                  @click="showMapNavigationStart"
                >
                  <van-icon name="guide-o" />
                  导航到救援位置
                </span>
              </template>
            </div>
          </div>
          <div class="address-box">
            <div class="address-item">
              <div class="address-round round-green" />
              <div>{{ taskDetail.contactAddress }}</div>
              <span class="card-distance">
                <span v-if="distance">距您{{ distance.toFixed(0) }}m</span>
                <span
                  style="color: #999999"
                  v-else
                >正在计算...</span>
              </span>
            </div>
            <div
              class="address-item address-destination"
              v-if="isTrailer"
            >
              <div class="address-round round-red" />
              <div v-if="taskDetail.destination">
                {{ taskDetail.destination }}
              </div>
              <div
                style="color: #ff8a59"
                v-else
              >
                未填写，请到达后和客户确认
              </div>
              <van-icon
                v-if="!(isWorkEndStatus || isAuditReturnStatus)"
                @click="editDestination"
                name="edit"
              />
            </div>
          </div>
          <div
            class="work-info"
            v-if="isWorkEndStatus || isAuditReturnStatus"
          >
            <span>作业时长：{{ operationTimeSlot }}</span>
            <span
              v-if="isTrailer"
            >作业里程：{{ actualOperationOrderDistance }}</span>
          </div>
        </div>
        <!-- 电子工单 -->
        <!-- <div
          class="card-box card-padding"
          v-if="!isAuditReturnStatus && isWorkEndStatus"
        >
          <div
            class="card-title card-title-flex"
            @click="goWorkOrders"
          >
            <div
              class="card-flex"
            >
              <img
                class="takeImg"
                src="@/assets/img/take_photo.png"
                alt=""
              >电子工单
            </div>
            <div>
              <span
                class="stateInfo"
                :class="{ isStateInfo: !isPerfection}"
              >{{ isPerfection ? '已完善' : '未完善' }}</span>
              <van-icon name="arrow" />
            </div>
          </div>
        </div> -->
        <div class="padding-box">
          <WorkOrders
            v-if="!isAuditReturnStatus && isWorkEndStatus"
            :order-no="taskDetail.orderNo"
            :task-no="taskDetail.taskNo"
            @clickHandler="setCurrentScrollTop"
          />
        </div>
        <!-- 作业凭证 -->
        <div class="card-box card-padding">
          <div class="card-title card-title-flex">
            <div class="">
              <span>作业凭证</span>
            </div>
          </div>
          <van-divider style="margin: 16px -16px" />
          <!-- <van-button
            type="info"
            size="large"
            @click="toPhoto"
          >去拍照</van-button> -->
          <Certificate
            v-if="taskDetail.taskNo"
            :photo-params="photoParams"
          />
        </div>

        <!-- 作业备注 -->
        <div
          class="card-box card-padding"
          v-if="isWorkEndStatus"
        >
          <div class="card-title card-title-flex">
            <span>作业备注</span>
          </div>
          <van-field
            class="textarea-box"
            v-model="orderRemark"
            rows="3"
            autosize
            type="textarea"
            placeholder="本次服务，你想说点什么吗？"
            maxlength="300"
            show-word-limit
          />
        </div>

        <!-- 确认弹窗 -->
        <ConfirmDialog ref="confirmDialog" />

        <!-- 选择地址弹窗 -->
        <SelectLocation
          ref="selectLocation"
          @confirm="locationConfirm"
        />

        <SelectMapNavigation ref="selectMapNavigation" />

        <!-- 日期选择器弹出层 -->
        <van-popup
          v-model="showDatePicker"
          round
          position="bottom"
        >
          <van-datetime-picker
            type="datetime"
            :min-date="dateRange.minDate"
            :max-date="dateRange.maxDate"
            :formatter="dateFormatter"
            @confirm="onDateConfirm"
            @cancel="showDatePicker = false"
          />
        </van-popup>
        <!-- 增值产品 -->
        <ExtraProductBox ref="extraProductBox" />
      </div>
    </div>
    <div
      class="bottom-box"
      v-if="sliderText"
    >
      <!-- 底部滑动条 -->
      <ClickButton
        ref="clickButton"
        @sliderCompleted="sliderCompleted"
      >
        {{ sliderText }}
      </ClickButton>
    </div>
    <!-- 去到底部 -->
    <ShowMore
      ref="showMoreRef"
      wrap-box="top-box"
    />
    <!-- 联系坐席 -->
    <PhoneCall2 />
    <!-- 联系客户 -->
    <PhoneCall
      v-if="taskDetail.contactPhone && !isAuditReturnStatus"
      :phone="taskDetail.contactPhone"
      :task-no="taskDetail.taskNo"
      :task-status="taskDetail.taskStatus"
    />
    <!-- 长城预约时间修改 -->
    <AppointmentTimeAlertView
      ref="appointmentTimeAlertViewRef"
      :task-no="taskNo"
      @confirm="getTaskDetail"
    />
    <AppointmentCheckTipsDialog ref="appointmentCheckTipsDialogRef" />
    <!-- 平安判断服务商能否预约 -->
    <DelayTipsDialog ref="delayTipsDialogRef" />
  </div>
</template>

<script>
import dayjs from 'dayjs';
import ClickButton from '@/components/clickButton.vue';
import ConfirmDialog from '@/components/confirmDialog.vue';
import PhoneCall from '../components/phoneCall.vue';
import PhoneCall2 from '../components/phoneCall2.vue';
import Certificate from '../components/certificate.vue';
import WorkOrders from '../components/workOrders.vue';
import ShowMore from '../components/showMore.vue';
import SelectLocation from '../components/selectLocation.vue';
import SelectMapNavigation from '../components/selectMapNavigation.vue';
import ExtraProductBox from '../components/extraProductBox.vue';
import {
  ORDER_STATUS_CODE,
  TASK_STATUS_CODE,
  generalProductCode
} from '@/common/constant';
import { PRODUCT_CODE_TYPE } from '@/common/product-config';
import {
  getTaskDetail,
  getRightRemark,
  beginWork,
  finishWork,
  getRescueReport,
  getMediaTemplate
} from '@/common/apiPaic.js';
import {
  updateAppointment,
  workerSetOut,
  workerArrive,
  endWork,
  reAudit,
  appSaveInfo,
  updateAppointmentCheck
} from '@/common/apiGeneral.js';
import { handleClipboard } from '@/common/clipboard';
import { mapActions } from 'vuex';
import CountDown from 'vue2-countdown';
import CountUp from '../components/countUp';
import getCurrentPositionMixin from '../mixins/getCurrentPositionMixin';
import AppointmentTimeAlertView from '../components/appointmentTimeAlertView.vue';
import AppointmentCheckTipsDialog from '../components/appointmentCheckTipsDialog.vue';
import { Dialog } from 'vant';
import DelayTipsDialog from '@/components/delayTipsDialog.vue';
export default {
  name: 'GeneralOrderAccidentRescue',
  mixins: [getCurrentPositionMixin],
  components: {
    ClickButton,
    ConfirmDialog,
    PhoneCall,
    PhoneCall2,
    SelectLocation,
    SelectMapNavigation,
    CountDown,
    ExtraProductBox,
    CountUp,
    Certificate,
    WorkOrders,
    ShowMore,
    AppointmentTimeAlertView,
    AppointmentCheckTipsDialog,
    DelayTipsDialog
  },
  data() {
    return {
      TASK_STATUS_CODE,
      productCodeType: PRODUCT_CODE_TYPE,
      orderNo: '',
      taskNo: '',
      taskDetail: {},
      rightRemark: '',
      extraProductStringList: [],
      showDatePicker: false,
      useTraceCar: 0,
      pictureTypes: [],
      imageInfo: {},
      remainderNotifyHeight: '',
      dateRange: {
        minDate: new Date(),
        maxDate: new Date()
      },
      orderRemark: '',
      reportData: {},
      copyText: ''
    };
  },
  computed: {
    // 是否已接单
    isTakeStatus() {
      return this.taskDetail.taskStatus === TASK_STATUS_CODE.take;
    },
    // 是否已出发
    isStartStatus() {
      return this.taskDetail.taskStatus === TASK_STATUS_CODE.start;
    },
    // 是否已到达
    isArriveStatus() {
      return this.taskDetail.taskStatus === TASK_STATUS_CODE.arrive;
    },
    // 是否作业开始
    isworkStartStatus() {
      return this.taskDetail.taskStatus === TASK_STATUS_CODE.workStart;
    },
    // 是否作业结束
    isWorkEndStatus() {
      return this.taskDetail.taskStatus === TASK_STATUS_CODE.workEnd;
    },
    // 是否作业完成
    isFinishStatus() {
      return this.taskDetail.taskStatus === TASK_STATUS_CODE.finish;
    },
    // 是否审核/结算退回
    isAuditReturnStatus() {
      return [
        ORDER_STATUS_CODE.auditReturn,
        ORDER_STATUS_CODE.settlementReturn
      ].includes(this.taskDetail.orderStatus);
    },
    // 是否审核退回
    isAuditReturn() {
      return this.taskDetail.orderStatus === ORDER_STATUS_CODE.auditReturn;
    },
    // 是否结算退回
    isSettlementReturn() {
      return this.taskDetail.orderStatus === ORDER_STATUS_CODE.settlementReturn;
    },
    distance() {
      if (
        this.currentPosition &&
        this.currentPosition.latitude &&
        this.currentPosition.longitude &&
        this.taskDetail &&
        this.taskDetail.latitude &&
        this.taskDetail.longitude
      ) {
        // 返回 p1 到 p2 间的地面距离，单位：米
        const distance = AMap.GeometryUtil.distance(
          [this.currentPosition.longitude, this.currentPosition.latitude],
          [this.taskDetail.longitude, this.taskDetail.latitude]
        );
        return distance;
      }
      return false;
    },
    // 事故拖车
    isTrailer() {
      return (
        this.taskDetail &&
        [generalProductCode.categoryCode_FL90000002].includes(
          this.taskDetail.categoryCode
        )
      );
    },
    sliderText() {
      let sliderText = '';
      if (
        [
          ORDER_STATUS_CODE.auditReturn,
          ORDER_STATUS_CODE.settlementReturn
        ].includes(this.taskDetail.orderStatus)
      ) {
        sliderText = '点击重新提审';
      } else {
        switch (this.taskDetail.taskStatus) {
          // 待服务
          case TASK_STATUS_CODE.take:
            sliderText = '点击已出发';
            break;
          // 待到达现场
          case TASK_STATUS_CODE.start:
            sliderText = '点击确定到达服务地点';
            break;
          // 已到达
          case TASK_STATUS_CODE.arrive:
            sliderText = '点击开始作业';
            break;
          // 开始拖车
          case TASK_STATUS_CODE.workStart:
            sliderText = '点击结束作业';
            break;
          // 拖车结束
          case TASK_STATUS_CODE.workEnd:
            sliderText = '点击服务完成';
            break;

          default:
            break;
        }
      }
      return sliderText;
    },
    operationTimeSlot() {
      const utc = require('dayjs/plugin/utc');
      dayjs.extend(utc);
      const operationTimeSlot = this.taskDetail.operationTimeSlot || 0;
      return dayjs.unix(operationTimeSlot).utc().format('HH:mm:ss');
    },
    actualOperationOrderDistance() {
      const actualOperationOrderDistance =
        this.taskDetail.actualOperationOrderDistance || 0;
      return actualOperationOrderDistance >= 1000
        ? (actualOperationOrderDistance / 1000).toFixed(1) + 'km'
        : actualOperationOrderDistance + 'm';
    },
    // 预约时间超时
    showYuyueTimeOut() {
      // 非实时单
      const condition1 =
        this.taskDetail.appointmentTime &&
        !this.taskDetail.appointmentTime.includes('实时');
      // 已接单或已出发
      const condition2 = this.isTakeStatus || this.isStartStatus;
      const now = dayjs();
      const appointmentTime = dayjs(this.taskDetail.appointmentTime);
      const diff = appointmentTime.diff(now, 'minutes', true);
      // 预约时间超过当前时间
      const condition = diff < 0;
      return condition1 && condition2 && condition;
    },
    showArriveTimeCountDown() {
      // 非实时单
      const condition1 =
        this.taskDetail.appointmentTime &&
        !this.taskDetail.appointmentTime.includes('实时');
      // 已接单或已出发
      const condition2 = this.isTakeStatus || this.isStartStatus;
      const now = dayjs();
      const appointmentTime = dayjs(this.taskDetail.appointmentTime);
      const diff = appointmentTime.diff(now, 'minutes', true);
      console.log('diff: ', diff);
      // 预约时间-当前时间<=60min才显示
      const condition3 = diff <= 60;
      // 预约时间未超过当前时间
      const condition4 = diff >= 0;
      return condition1 && condition2 && condition3 && condition4;
    },
    showRemainderNotify() {
      return (
        this.taskDetail.remainderCount > 0 &&
        (this.isTakeStatus || this.isStartStatus)
      );
    },
    // 是否完善
    isPerfection() {
      return (
        this.reportData.customerSign &&
        this.reportData.operatorSign &&
        this.reportData.carStatus
      );
    },
    photoParams() {
      return {
        orderNo: this.orderNo,
        taskNo: this.taskNo,
        useTraceCar: this.useTraceCar,
        pictureTypes: this.pictureTypes
      };
    },
    // 是否显示至尊vip
    isShowZvVip() {
      return (
        this.taskDetail.tagCodes &&
        this.taskDetail.tagCodes.includes('VIP_CUSTOMER_ZV')
      );
    },
    // 是否显示黑钻客户
    isShowBcCustomer() {
      return (
        this.taskDetail.tagCodes &&
        this.taskDetail.tagCodes.includes('VIP_CUSTOMER_BC')
      );
    },
    // 至尊vip和重点保司
    isZvVipAndVipCompany() {
      return (
        this.taskDetail.vipCompany === '1' &&
        (this.isShowZvVip || this.isShowBcCustomer)
      );
    },
    isCCQC() {
      // 长城汽车
      return this.taskDetail && this.taskDetail.channelCompanyNo === 'CCQC';
    },
    isPiccAppointmentCheckOrder() {
      return this.taskDetail &&
        this.taskDetail.channelCompanyNo === 'PICC';
    },
    isRoadRescueType() {
      // 道路救援、困境救援、事故救援 显示当前模块
      const { roadRescueType, distressRescueType, accidentRescueType } =
        this.productCodeType;
      return (
        this.taskDetail &&
        [
          ...roadRescueType,
          ...distressRescueType,
          ...accidentRescueType
        ].includes(this.taskDetail.categoryCode)
      );
    }
  },
  created() {
    const { orderNo, taskNo } = this.$route.params;
    if (taskNo) {
      this.orderNo = orderNo;
      this.taskNo = taskNo;
      this.getTaskDetail();
      this.getCurrentPosition();
    }
  },
  activated() {
    this.getRescueReport();
  },
  methods: {
    ...mapActions('orderGeneral', ['setOrderStatus', 'setTaskStatus']),
    async getRescueReport() {
      try {
        const data = await getRescueReport({
          orderNo: this.orderNo,
          taskNo: this.taskNo
        });
        if (data) {
          this.reportData = data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    goWorkOrders() {
      this.$router.push({
        name: 'GeneralOrderWorkOrders',
        params: {
          orderNo: this.orderNo,
          taskNo: this.taskNo
        },
        query: {
          isH5: true
        }
      });
    },
    async getRemainderNotifyHeight() {
      await this.$nextTick();
      const vanNotify = document.getElementsByClassName('van-notify')[0];
      this.remainderNotifyHeight = vanNotify ? vanNotify.offsetHeight : '';
    },
    showExtraProductBox() {
      this.$refs.extraProductBox.open({
        title: '增值产品（客户实际使用的增值产品）',
        extraProduct: this.taskDetail.extraProduct || [],
        extraParam: {
          orderNo: this.orderNo,
          taskNo: this.taskNo
        },
        confirmCallback: () => {
          this.getTaskDetail();
        },
        cancelCallback: () => {}
      });
    },
    currentTime() {
      return Date.now();
    },
    getTime(time) {
      return new Date(time).getTime();
    },
    async editTime() {
      // 长城
      if (this.isCCQC) {
        const res = { appointmentTime: this.taskDetail.appointmentTime };
        this.$refs.appointmentTimeAlertViewRef.open(res);
        return;
      }
      if (this.taskDetail.isPaicOrder === 1 || this.isPiccAppointmentCheckOrder) {
        await this.handleUpdateAppointmentCheck({
          onPass: () => {
            if (this.taskDetail.isPaicOrder === 1) {
              this.falseAppointmentBooking();
              return;
            }
            this.editTimeOption();
          }
        });
        return;
      }
      this.editTimeOption();
    },
    async handleUpdateAppointmentCheck({ onPass }) {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true
      });
      try {
        const res = await updateAppointmentCheck({
          taskNo: this.taskNo
        });
        this.$toast.clear();
        if (res && res.code) {
          if (res.code === '7009') {
            this.$refs.delayTipsDialogRef.open({
              content: res.message || '到勘时效短，仍需预约请联系中保客服，经核实非真实预约将处罚',
              confirmCallback: () => {
              }
            });
            return;
          }
          if (res.code === '7016') {
            this.openAppointmentCheckTipsDialog(res.message || '请引导客户重新下单');
            return;
          }
          if (res.code === '7017') {
            this.openAppointmentTimeoutDialog(res.message || '已超时，此单无法预约');
            return;
          }
        }
        onPass && onPass();
      } catch (error) {
        this.$toast.clear();
        console.log(error);
      }
    },
    falseAppointmentBooking() {
      if (this.taskDetail.appointmentTime.includes('实时')) {
        const that = this;
        Dialog.confirm({
          title: '提示',
          message: '<span style="color: red;">虚假打预约，将处以高额罚款，请确认是否预约</span>',
          confirmButtonText: '是',
          cancelButtonText: '否',
          allowHtml: true,
          confirmButtonColor: '#3399FF'
        })
          .then(() => {
            that.editTimeOption();
          })
          .catch(() => {
          });
      } else {
        this.editTimeOption();
      }
    },
    openAppointmentCheckTipsDialog(content) {
      this.$refs.appointmentCheckTipsDialogRef.open({
        content,
        warningText: '注意：修改预约需客户线上确认后才能生效',
        okCallback: () => {
          this.toCancelOrderPage();
        },
        insistCallback: () => {
          this.openInsistAppointmentDialog();
        }
      });
    },
    openAppointmentTimeoutDialog(content) {
      this.$refs.confirmDialog.open({
        title: '提示',
        showConfirmButton: true,
        showCancelButton: false,
        confirmButtonText: '好的',
        confirmText: content
      });
    },
    openInsistAppointmentDialog() {
      this.$refs.appointmentTimeAlertViewRef.open({
        appointmentTime: this.taskDetail.appointmentTime,
        needReason: false,
        dateRangeGetter: () => this.getInsistAppointmentDateRange()
      });
    },
    getInsistAppointmentDateRange() {
      const now = dayjs();
      return {
        minDate: now.add(1, 'hour').add(1, 'minute').toDate(),
        maxDate: now.add(7, 'day').subtract(1, 'minute').toDate()
      };
    },
    toCancelOrderPage() {
      this.$router.push({
        name: 'GeneralOrderCancelOrder',
        params: {
          fromPage: this.$route.name,
          orderNo: this.orderNo,
          taskNo: this.taskNo
        }
      });
    },
    editTimeOption() {
      // 只能选择今天起，7天内的日期（含今天）
      const now = dayjs();
      const minDate = now.add(1, 'minute');

      let maxDate = now.add(6, 'day');
      maxDate = maxDate.set('hour', 23);
      maxDate = maxDate.set('minute', 59);
      maxDate = maxDate.set('second', 59);
      maxDate = maxDate.subtract(1, 'minute');

      this.dateRange = {
        minDate: new Date(minDate),
        maxDate: new Date(maxDate)
      };
      this.showDatePicker = true;
    },
    onDateConfirm(date) {
      this.showDatePicker = false;
      const res = dayjs(date).format('YYYY-MM-DD HH:mm');
      this.updateAppointment(res);
    },
    locationConfirm() {
      this.getTaskDetail();
    },
    dateFormatter(type, val) {
      switch (type) {
        case 'year':
          return val + '年';
        case 'month':
          return val + '月';
        case 'day':
          return val + '日';
        case 'hour':
          return val + '点';
        case 'minute':
          return val + '分';
        default:
          return val;
      }
    },
    showMapNavigationStart() {
      this.$refs.selectMapNavigation.open(
        this.taskDetail.contactAddress,
        this.taskDetail.longitude,
        this.taskDetail.latitude
      );
    },
    showMapNavigationEnd() {
      this.$refs.selectMapNavigation.open(
        this.taskDetail.destination,
        this.taskDetail.destLongitude,
        this.taskDetail.destLatitude
      );
    },
    editDestination() {
      this.$refs.selectLocation.open(
        this.currentPosition,
        this.taskNo,
        this.taskDetail.taskStatus
      );
    },
    copy(e, txt) {
      handleClipboard(txt, e);
    },
    // 滑动到底
    async sliderCompleted() {
      // 状态流转
      await this.statusChange();
      this.$refs.clickButton.reset();
    },
    // 跳转照片页面
    async toPhoto() {
      const params = {
        orderNo: this.orderNo,
        taskNo: this.taskNo,
        useTraceCar: this.useTraceCar,
        pictureTypes: this.pictureTypes
      };
      const router = {
        name: 'GeneralOrderCertificate',
        query: {
          photoParams: JSON.stringify(params)
        }
      };
      console.log('router: ', router);
      this.$router.push(router);
    },
    // 页面跳转
    toPage(name) {
      const router = {
        name,
        params: {
          orderNo: this.orderNo,
          taskNo: this.taskNo
        }
      };
      this.$router.replace(router);
    },
    async getTaskDetail(noLoading) {
      if (!(this.orderNo && this.taskNo)) {
        return;
      }
      if (!noLoading) {
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true
        });
      }
      try {
        const data = await getTaskDetail({
          orderNo: this.orderNo,
          taskNo: this.taskNo
        });
        if (data) {
          this.taskDetail = data;
          const extraProduct = this.taskDetail.extraProduct || [];
          this.extraProductStringList = extraProduct.map(
            (item) => `${item.name}(${Number(item.value)})`
          );
          this.getRightRemark();
          this.setOrderStatus(this.taskDetail.orderStatus);
          this.setTaskStatus(this.taskDetail.taskStatus);
          this.getRemainderNotifyHeight();
          // 获取可复制的服务凭证信息
          this.getMediaTemplate();
        }
        if (!noLoading) {
          this.$toast.clear();
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 获取影像模板
    async getMediaTemplate() {
      const res = await getMediaTemplate({
        orderNo: this.orderNo,
        templateType: 'mainTemplate',
        source: 4
      });
      if (res) {
        const data = res || [];
        const arr = [];
        for (const item of data) {
          if (item.secondary) {
            const arr2 = [];
            for (const item2 of item.secondary) {
              if (item2.requiredNum > 0) {
                arr2.push(item2.typeName);
              }
            }
            if (arr2.length > 0) {
              arr.push(`${item.primaryName}(${arr2.join('、')})`);
            }
          }
        }
        this.copyText = this.taskDetail.orderNo + '\n' + arr.join('、');
      }
    },
    async getRightRemark() {
      if (!(this.orderNo && this.taskNo)) {
        return;
      }
      try {
        const data = await getRightRemark({
          orderNo: this.orderNo
        });
        this.rightRemark = data.resultValue;
      } catch (error) {
        console.log(error);
      }
    },
    async updateAppointment(appointmentTime) {
      if (!(this.orderNo && this.taskNo)) {
        return;
      }
      try {
        const res = await updateAppointment({
          taskNo: this.taskNo,
          appointmentTime
        });
        if (res && res.code) {
          if (res.code === '7009') {
            this.$refs.delayTipsDialogRef.open({
              content: res.message || '到勘时效短，仍需预约请联系中保客服，经核实非真实预约将处罚',
              confirmCallback: () => {
              }
            });
            return;
          }
        }
        this.$toast('修改成功');
        this.getTaskDetail();
      } catch (error) {
        console.log(error);
      }
    },
    async statusChange(noLoading) {
      if (!this.currentPosition) {
        this.$toast('当前位置获取失败，请确认是否打开位置权限！');
        return;
      }
      let statusChangeApi = '';
      if (
        [
          ORDER_STATUS_CODE.auditReturn,
          ORDER_STATUS_CODE.settlementReturn
        ].includes(this.taskDetail.orderStatus)
      ) {
        statusChangeApi = reAudit;
      } else {
        switch (this.taskDetail.taskStatus) {
          // 待服务
          case TASK_STATUS_CODE.take:
            statusChangeApi = workerSetOut;
            break;
          // 待到达现场
          case TASK_STATUS_CODE.start:
            statusChangeApi = workerArrive;
            break;
          // 已到达
          case TASK_STATUS_CODE.arrive:
            statusChangeApi = beginWork;
            break;
          // 开始拖车
          case TASK_STATUS_CODE.workStart:
            statusChangeApi = endWork;
            break;
          // 拖车结束
          case TASK_STATUS_CODE.workEnd:
            statusChangeApi = finishWork;
            break;

          default:
            break;
        }
      }

      if (!noLoading) {
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true
        });
      }
      try {
        if (this.orderRemark) {
          await appSaveInfo({
            remark: this.orderRemark,
            orderNo: this.taskDetail.orderNo,
            taskNo: this.taskDetail.taskNo
          });
        }
        await statusChangeApi({
          taskNo: this.taskDetail.taskNo,
          ...this.currentPosition
        });

        if (!noLoading) {
          this.$toast.clear();
        }
        this.orderRemark = '';
        if (!(this.isAuditReturnStatus || this.isWorkEndStatus)) {
          this.getTaskDetail();
        } else {
          this.toPage('GeneralOrderExecuted');
        }
      } catch (error) {
        console.log(error);
      }
    },
    setCurrentScrollTop() {
      this.$refs.showMoreRef && this.$refs.showMoreRef.setCurrentScrollTop();
    }
  }
};
</script>

<style lang="scss" scoped>
.wrap-box {
  .van-notify {
    top: 46px;

    display: flex;
    .van-notify-label {
      flex: 70px 0 0;
    }
    .van-notify-value {
      word-break: break-all;
    }
  }
  .count-down {
    color: #ea9443;
    ::v-deep i {
      font-style: normal;
    }
  }
  .top-box {
    overflow-y: auto;

    height: calc(100vh - 72px - 46px);

    background: #f2f3f5;
  }
  .bottom-box {
    height: 72px;
  }
}
.flex-box {
  display: flex;
}
.content-box {
  padding-bottom: 32px;

  .car-info-box {
    padding: 13px 16px 15px;

    background: #ffffff;

    .vip-icon {
      width: 19px;
      height: 18px;
      margin-top: 2px;
      margin-left: 4px;
    }

    .zv-vip-icon {
      margin-left: 4px;
      margin-top: 2px;
      padding: 0 4px;
      text-align: center;
      letter-spacing: 0;
      color: #ffffff;
      border-radius: 4px;
      background: #f32222;
      font-family: PingFangSC-Regular;
      font-size: 10px;
      font-weight: 400;
      line-height: 18px;
      height: 18px;
      white-space: nowrap;
    }

    .copy-btn {
      width: 32px;
      height: 18px;
      margin-left: 4px;
      padding: 2px 6px;

      text-align: center;
      white-space: nowrap;

      color: #3399ff;
      border: 1px solid #3399ff;
      border-radius: 100px;
      background: #eaf4ff;

      font-size: 10px;
      font-weight: 400;
      line-height: 18px;
    }

    .order-no-item {
      display: flex;
      align-items: baseline;
      justify-content: space-between;

      letter-spacing: -0.41px;

      color: #383838;

      font-family: PingFangSC-Medium;
      font-size: 16px;
      font-weight: 500;
      line-height: 18px;

      .order-no-item-left {
        display: flex;
        flex-wrap: wrap;
      }

      .car-no {
        margin-right: 8px;
      }

      .order-polymerize {
        padding: 1px 8px;

        text-align: center;
        letter-spacing: -0.31px;

        color: #ffffff;
        border-radius: 9px 9px 9px 0px;
        background: #ff8a59;

        font-family: PingFangSC-Medium;
        font-size: 12px;
        font-weight: 500;
      }
    }

    .car-info-item {
      display: flex;

      letter-spacing: -0.38px;

      color: #646464;

      font-family: PingFangSC-Regular;
      font-size: 15px;
      font-weight: 400;
      line-height: 21px;

      .copy-btn {
        color: #3399ff;
      }

      .van-tag {
        margin-left: 8px;
        padding: 1px 4px;
      }

      & + .car-info-item {
        padding-top: 8px;
      }
      .carNo {
        padding: 0;
      }
      .car_red {
        color: #f32222;
      }

      .divider {
        padding: 0 5px 0 10px;

        color: #e3e3e3;
      }
      .txt-btn {
        padding: 0 5px;

        color: #3399ff;

        font-size: 10px;
      }
      span {
        &:first-child {
          flex: 0 0 74px;
        }
        & + span {
          color: #383838;
        }
        &.car-no {
          font-family: PingFangSC-Medium;
          font-weight: 500;

          &.color-red {
            color: #f32222;
          }

          &.order-no {
            flex: 0 0 150px;

            word-break: break-all;
          }
          &.order-svip {
            flex: 0 0 100px;
            word-break: break-all;
          }
        }
      }
      .edit {
        margin: 2px 10px;

        color: #3399ff;
      }
    }
  }

  .padding-box {
    margin: 12px 12px 0;
  }

  .card-box {
    margin: 12px 12px 0;

    border-radius: 8px;
    background: #ffffff;

    &.card-padding {
      padding: 16px;
    }

    ::v-deep .card-title,
    .card-title {
      letter-spacing: -0.41px;

      color: #383838;

      font-family: PingFangSC-Medium;
      font-size: 16px;
      font-weight: 500;
      line-height: 22px;

      &.card-title-flex {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .order-tag {
        margin-left: 4px;
        padding: 0 4px;

        text-align: right;
        letter-spacing: -0.26px;

        color: #d36868;
        border-radius: 1px;
        background: #ffe7e7;

        font-family: PingFangSC-Regular;
        font-size: 10px;
        font-weight: 400;
      }

      .card-title-info {
        display: flex;
        align-items: center;

        letter-spacing: -0.38px;

        color: #383838;

        font-family: PingFangSC-Regular;
        font-size: 15px;
        font-weight: 400;
        line-height: 21px;

        .van-icon {
          margin-left: 8px;

          color: #999999;

          font-size: 16px;
        }
      }

      .card-tips {
        letter-spacing: -0.38px;

        font-family: PingFangSC-Regular;
        font-size: 15px;
        font-weight: 400;
        line-height: 21px;
        &.card-tips__red {
          color: #f32222;
        }
      }
      .card-tips__gary {
        color: #787878;

        font-size: 12px;
      }
      .card-tag {
        margin-left: 8px;
        padding: 1px 8px 2px;

        letter-spacing: -0.31px;

        border-radius: 2px;

        font-family: PingFangSC-Regular;
        font-size: 12px;
        font-weight: 400;
        line-height: 17px;

        &.card-tag__red {
          color: #c78062;
          background: #fff0ea;
        }
      }
      .card-text-btn {
        text-align: right;
        letter-spacing: -0.38px;

        color: #3399ff;

        font-family: PingFangSC-Regular;
        font-size: 15px;
        font-weight: 400;
        line-height: 21px;
      }
    }

    .address-box {
      margin-top: 12px;
      padding: 16px;

      border-radius: 8px;
      background-color: #eff6f5;
      .address-item {
        display: flex;
        align-items: baseline;

        color: #383838;

        font-size: 14px;
        line-height: 21px;

        & + .address-item {
          margin-top: 12px;
        }

        .address-round {
          flex: 10px 0 0;

          width: 10px;
          height: 10px;
          margin-right: 8px;

          border-radius: 100%;
          &.round-green {
            background-color: #76c16d;
          }
          &.round-red {
            background-color: #ef9164;
          }
        }
        &.address-destination {
          color: #7a7f7f;
        }

        .card-distance {
          flex: 70px 0 0;

          text-align: right;
          letter-spacing: -0.38px;

          color: #646464;

          font-family: PingFangSC-Regular;
          font-size: 12px;
          font-weight: 400;
          line-height: 21px;
        }

        .van-icon {
          margin-left: 8px;

          font-size: 16px;
        }
      }
    }

    .work-info {
      padding-top: 12px;

      letter-spacing: -0.38px;

      font-size: 16px;
      font-weight: 500;
      line-height: 21px;

      span + span {
        padding-left: 8px;
      }
    }

    .car-remark {
      margin-top: 11px;

      letter-spacing: -0.38px;

      color: #646464;

      font-family: PingFangSC-Regular;
      font-size: 15px;
      font-weight: 400;
      line-height: 21px;
    }

    .card-info {
      margin-top: 10px;

      color: #383838;

      font-size: 15px;
    }
    .card-tips__red {
      color: #f32222;
    }

    ::v-deep .van-checkbox {
      letter-spacing: -0.38px;

      color: #383838;

      font-family: PingFangSC-Regular;
      font-size: 15px;
      font-weight: 400;
      .van-checkbox__icon {
        font-size: 16px;
        &.van-checkbox__icon--checked .van-icon {
          border-color: #3399ff;
          background-color: #3399ff;
        }
        .van-icon {
          border: 1px solid rgba(153, 153, 153, 1);
          border-radius: 4px;
        }
      }
    }

    .placeholder-box {
      margin-bottom: 24px;
    }

    .van-button {
      text-align: center;
      letter-spacing: -0.38px;

      border-radius: 8px;

      font-family: PingFangSC-Regular;
      font-size: 15px;
      font-weight: 400;
      line-height: 21px;

      &.van-button--info {
        color: #ffffff;
        border-color: #3399ff;
        background-color: #3399ff;
      }

      &.van-button--large {
        height: 39px;
      }
    }
  }

  .select-box {
    .select-item {
      padding: 5px 10px;

      text-align: center;
      letter-spacing: -0.38px;

      color: #646464;
      border-radius: 4px;
      background: #e1e7ed;

      font-family: PingFangSC-Regular;
      font-size: 15px;
      font-weight: 400;
      &.active {
        color: #ffffff;
        background: #3399ff;
      }
    }
  }
  .collapse {
    border-bottom: 1px solid #e6e6e6;
    .isActive {
      color: #ff8a59;

      font-size: 12px;
    }
    ::v-deep .accidentValue {
      color: #3399ff;
    }
    ::v-deep .van-cell__right-icon {
      color: #3399ff;
    }
    ::v-deep .van-cell {
      padding: 10px 0;
    }
    ::v-deep .van-collapse-item__content {
      padding: 5px 0;
    }
  }
  .collapse:last-child {
    border-bottom: 0;
  }

  .textarea-box,
  ::v-deep .textarea-box {
    margin-top: 12px;
    padding: 12px;

    letter-spacing: -0.38px;

    border: 1px solid rgba(200, 200, 200, 1);
    border-radius: 8px;
    background: #ffffff;

    font-family: PingFangSC-Regular;
    font-size: 15px;
    font-weight: 400;
    line-height: 21px;

    ::v-deep .van-field__control {
      color: #383838;

      &::placeholder {
        color: #c8c8c8;
      }
    }
  }
}
.select-box {
  display: flex;
  flex-wrap: wrap;
  .select-item {
    min-width: 30px;
    margin: 0 10px 10px 0;
    padding: 5px 10px;

    text-align: center;
    letter-spacing: -0.38px;

    color: #646464;
    border-radius: 4px;
    background: #e1e7ed;

    font-family: PingFangSC-Regular;
    font-size: 15px;
    font-weight: 400;
    line-height: 21px;

    &.active {
      color: #ffffff;
      background: #3399ff;
    }
  }
}
.card-title-sub {
  // font-weight: 500;
  padding: 10px 0 15px;

  color: #787878;
  border-bottom: 1px solid #e6e6e6;

  font-family: PingFangSC-Medium;
  font-size: 15px;
}

.map-btn {
  margin-left: 20px;
  padding: 2px 8px;

  color: #3399ff;
  border: 1px solid #3399ff;
  border-radius: 20px;

  font-size: 10px;
}
.card-flex {
  display: flex;
  align-items: center;
}
.takeImg {
  width: 35px;
  margin-right: 10px;
}
.stateInfo {
  margin-right: 10px;

  color: #383838;

  font-size: 15px;
  font-weight: 400;
}
.isStateInfo {
  color: #f32222;
}
</style>
